import type { CreateMachineRequest, MachineEntity } from "../../domain/types/machine";
import { MachineEntitySchema } from "../../domain/types/machine";
import type { MachineRepository } from "../../domain/repositories/machine-repository";
import { machineApiService } from "../api/machine-api-service";

export class MachineRepositoryImpl implements MachineRepository {
  async createMachine(
    routerId: number,
    request: CreateMachineRequest,
  ): Promise<MachineEntity> {
    const response = await machineApiService.createMachine(routerId, request);

    if (response.data) {
      return MachineEntitySchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "기계 생성 실패.");
  }
}